export const ANNUAL_PRICING_DISCOUNT: Record<string, number> = {
  creator: 0.34,
  creator_pro: 0.35,
};

export const getDiscountedYearlyUnitAmount = (category: string, unitAmount: number): number => {
  const discount = ANNUAL_PRICING_DISCOUNT[category];
  return discount ? Math.round(unitAmount * (1 - discount)) : unitAmount;
};
